import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../../../apiclient/apiclient";
import OrderCard from "./OrderCard";
import socket from "../../../socket/socketClient";
import { ArrowLeft } from "lucide-react";
import PageHeader from "../../../components/PageHeader";
import Loader from "../../../components/Loader";
const PendingOrders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
 const [loading, setLoading] = useState(true);
const loadOrders = async () => {
  try {
    setLoading(true);

    const res = await apiClient.get("/all-order?status=pending");

    //console.log("Delivered API response:", res.data); // 🔎 debug

    setOrders(res.data.data || []);
  } catch (error) {
    console.error("Error loading pending orders", error);
    setOrders([]);
  } finally {
    setLoading(false); // ✅ VERY IMPORTANT
  }
};

  useEffect(() => {
    loadOrders();
  }, []);

  /* 🔴 REALTIME UPDATE */
  useEffect(() => {
    const refresh = () => loadOrders();

    const events = [
      "order_created",       // new order
      "order_accepted",        // new order
      "order_status_updated",// accepted, shipped, etc
      "order_updated",       // generic updates
      "order_deleted",       // order removed
    ];

    events.forEach(ev => socket.on(ev, refresh));

    return () => {
      events.forEach(ev => socket.off(ev, refresh));
    };
  }, []);

  return (
    <div className="">
      {/* HEADER WITH BACK BUTTON */}
   <PageHeader
  title="Pending Orders"
  role="agent"
  subtitle="Orders waiting to be accepted"
  leftContent={
    <button
      onClick={() => navigate(-1)}
      className="p-2 rounded-lg hover:bg-gray-100 transition"
    >
      <ArrowLeft size={20} />
    </button>
  }
/>


       {loading ? (
  <Loader text="Loading pending orders..." />
) : orders.length === 0 ? (
  <p className="text-gray-500 text-center py-6">
    No pending orders
  </p>
) : (
  <div className="space-y-4 p-3">
    {orders.map((order) => (
      <OrderCard
        key={order._id}
        order={order}
        reload={loadOrders}
      />
    ))}
  </div>
)}
    </div>
  );
};

export default PendingOrders;
